module.exports = __webpack_public_path__ + "img/photo_campus.f8bd2a3.JPG";